// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"2":"blogPost","239":"blog","443":"about","631":"contact"}[chunkId] || chunkId) + "." + {"2":"c137f411","239":"482537a9","443":"bb0a6128","631":"b3f39f73","771":"4f9c8cb2"}[chunkId] + ".js";
};